import moment from "moment";

export const dateToString = (value?: Date, format = "DD.MM.YYYY") => {
  return value ? moment.utc(value).format(format) : "";
};

export const dateToMonthAndYear = (value?: Date) => {
  return value ? moment.utc(value).format("MM/YY") : "";
};

export const getCurrentYear = () => {
  return moment().year();
};
